import type { TFunction } from 'i18next';

import type { FilterDef } from '@nucleus-commerce/admin-kit/index-table';
import { ApiKeyKind, type ApiKey } from '@nucleus-commerce/api-client/admin';

import type { ApiKeyStatus } from './api-key-columns';

const STATUSES: readonly ApiKeyStatus[] = ['active', 'revoked'];

/** Filters of the API keys table; `t` is the `apiKeys` namespace. */
export function apiKeyFilters(t: TFunction): Array<FilterDef<ApiKey>> {
  return [
    {
      key: 'kind',
      label: t('columns.kind'),
      type: 'enum',
      pinned: true,
      aliases: ['type'],
      options: Object.values(ApiKeyKind).map((kind) => ({
        value: kind,
        label: t(`kind.${kind}`),
      })),
    },
    {
      key: 'status',
      label: t('columns.status'),
      type: 'enum',
      pinned: true,
      options: STATUSES.map((status) => ({ value: status, label: t(`status.${status}`) })),
    },
  ];
}
